/**
 * Hook for getting backend-authorized suggested messages.
 */
import { useMemo } from 'react';
import type { AssistantSuggestion, SuggestedMessage } from '@app-types/assistant.ts';

export interface UseSuggestedMessagesReturn {
  suggestedMessages: SuggestedMessage[];
  getSuggestionsByCategory: (category: string) => SuggestedMessage[];
}

const iconByIntent: Record<string, string> = {
  help: '?',
  catalog_search: 'S',
  promotions: '+',
};

export const useSuggestedMessages = (
  backendSuggestions: AssistantSuggestion[] = [],
): UseSuggestedMessagesReturn => {
  const suggestedMessages = useMemo<SuggestedMessage[]>(() => (
    backendSuggestions.map((suggestion) => ({
      text: suggestion.label,
      icon: iconByIntent[suggestion.intent_hint],
      category: suggestion.intent_hint,
      capability: suggestion.capability,
      intentHint: suggestion.intent_hint,
      suggestionId: suggestion.id,
    }))
  ), [backendSuggestions]);

  const getSuggestionsByCategory = (category: string): SuggestedMessage[] => {
    return suggestedMessages.filter((msg) => msg.category === category);
  };

  return {
    suggestedMessages,
    getSuggestionsByCategory,
  };
};
